import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function StickyMobileCTA() {
  return <div className="lg:hidden fixed bottom-0 left-0 right-0 z-50 bg-primary/95 backdrop-blur-md border-t border-text-primary/8 shadow-[0_-4px_24px_rgba(0,0,0,0.08)]" data-id="element-269">
      <div className="px-4 pt-2 pb-1" data-id="element-270">
        <p className="text-center text-[10px] text-text-secondary tracking-wide mb-1.5" data-id="element-271">
          Evaluación gratuita · 3 min · Sin compromiso
        </p>
      </div>
      <div className="px-4 pb-4" data-id="element-272">
        <motion.button whileTap={{
        scale: 0.96
      }} className="w-full bg-accent text-white font-bold uppercase tracking-wide text-[14px] py-4 rounded-full min-h-[52px] shadow-lg flex items-center justify-center space-x-2" data-id="element-273">
          <span data-id="element-274">Hacer test gratuito</span>
          <ArrowRight className="w-4 h-4" data-id="element-275" />
        </motion.button>
      </div>
    </div>;
}